import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ElementRef,
} from "@angular/core";
import { Router } from "@angular/router";
import { GraphicsInfo } from "../../../../domain/graphics-info";
import { Subscription } from "rxjs";
import { GraphicsRepository } from "../../../../domain/graphics-repository";
import { UI } from "../../../../services/ui.service";

@Component({
  selector: "graphic-library-item",
  templateUrl: "./graphicLibraryItem.component.html",
  styleUrls: ["./graphicLibraryItem.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GraphicLibraryItemComponent {
  @Input()
  item: GraphicsInfo;

  @Input()
  viewMode: string = "gallery";

  @Input()
  haveChildren: boolean = false;

  @Output()
  instancesClick = new EventEmitter<any>();
  graphicUpdatedSubscription: Subscription;

  constructor(
    private ui: UI,
    private ref: ElementRef,
    private router: Router,
    private graphicsRepository: GraphicsRepository,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.graphicUpdatedSubscription =
      this.graphicsRepository.graphicUpdated.subscribe(
        this.onGraphicsUpdate.bind(this),
      );
  }

  ngOnDestroy() {
    if (this.graphicUpdatedSubscription) {
      this.graphicUpdatedSubscription.unsubscribe();
    }
  }

  onGraphicsUpdate(graphicsInfo: GraphicsInfo) {
    if (!graphicsInfo.isTemplate && this.item.id === graphicsInfo.id) {
      this.item = graphicsInfo;
      this.changeDetectorRef.markForCheck();
    }
  }

  /**
   * Editing Graphic Element
   * @return void
   */
  deleteGraphic() {
    this.ui.notify(this.ui.EVENTS.ShowConfirm, {
      title: "Delete Graphic Instance",
      message: "Are you sure about it?",
      buttons: [
        {
          title: "Yes",
          callback: this.onDeleteConfirmed.bind(this),
        },
        {
          title: "No",
          callback: this.onDeleteCancelled.bind(this),
        },
      ],
    });
  }

  /**
   * confirmation handler for delete process
   * @param response
   */
  onDeleteConfirmed() {
    this.graphicsRepository
      .deleteInstance(this.item.id)
      .then(this.onDeleteSuccess.bind(this), (error) => {
        const message = error.error.Message;
        this.ui.notify(this.ui.EVENTS.ShowAlert, {
          title: "Delete",
          message: message,
        });
      })
      .catch((error) => {});
  }

  /**
   * delete cancellation handler
   * @return void
   */
  onDeleteCancelled() {}

  /**
   * On Delete Success (Dispatch when item been deleted)
   * @param response
   */
  onDeleteSuccess(response) {
    this.ref.nativeElement.remove();
  }

  /**
   * Editing Graphics Tempate
   * @return void
   */
  editGraphics() {
    if (this.item.isTemplate) {
      this.router.navigate(["/scheduler/graphics/new", this.item.id]);
    } else {
      this.router.navigate(["/scheduler/graphics/edit", this.item.id]);
    }
  }

  onDragStart(event: DragEvent) {
    event.dataTransfer.setData("text/graphics", JSON.stringify(this.item));
  }

  onInstancesClick() {
    this.instancesClick.emit();
  }
}
